import { render } from "./availablePartAddToBasket.vue?vue&type=template&id=6c56bdeb"
import script from "./availablePartAddToBasket.vue?vue&type=script&lang=js"
export * from "./availablePartAddToBasket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__